<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template functional>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <ul class="d-flex" style="gap: 50px; overflow-x: auto; padding: 10px;">
      <li>
        <router-link exact-active-class to="/purchases">شراء</router-link>
      </li>
      <!-- <li>
        <router-link exact-active-class to="/customers/payment"
          >تحصيل</router-link
        >
      </li> -->
      <li>
        <router-link exact-active-class to="/suppliers/payment"
          >سداد</router-link
        >
      </li>
      <li>
        <router-link exact-active-class to="/expenses/new">مصروف</router-link>
      </li>
      <li>
        <router-link exact-active-class to="/projects">المشاريع</router-link>
      </li>
      <li>
        <router-link exact-active-class to="/workers">الحرفيين</router-link>
      </li>
      <li>
        <router-link exact-active-class to="/cities">المُدن</router-link>
      </li>
      <li>
        <router-link exact-active-class to="/locations">المناطق</router-link>
      </li>
      <li>
        <router-link exact-active-class to="/jobs">المهن</router-link>
      </li>
      <li>
        <router-link exact-active-class to="/clients">العملاء</router-link>
      </li>
      <li>
        <router-link exact-active-class to="/Safe/report">الخزينه</router-link>
      </li>
    </ul>
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String,
    },
  },
  created() {
    console.log(this.$route.path);
  },
};
</script>
<style lang="scss">
.the-footer {
  .router-link-active {
    background: linear-gradient(
      -118deg,
      rgba(var(--vs-primary), 1),
      rgba(var(--vs-primary), 0.7)
    );
    box-shadow: 0px 0px 10px 1px rgba(var(--vs-primary), 0.7);
    color: #fff;
    padding: 3px 15px;
    border-radius: 10px;
  }
}
</style>
